import { useState } from "react";
import { CanAccess, useTranslate } from "ra-core";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Plus } from "lucide-react";

import { TopToolbar } from "../layout/TopToolbar";
import { TaskCreateSheet } from "./TaskCreateSheet";
import { TasksListContent } from "./TasksListContent";

/**
 * The desktop Tasks page.
 *
 * There was not one: the desktop <Resource name="tasks"> was registered with no
 * list, while the navigation linked to /tasks, so the page rendered blank. Only
 * the mobile shell had a task list.
 *
 * Rows come from TasksListByDueDate, the same component the mobile list and the
 * contact sidebar use, so due-date grouping and paging behave identically
 * wherever tasks appear.
 */
export const TaskList = () => {
  const translate = useTranslate();
  const [createOpen, setCreateOpen] = useState(false);

  return (
    <div className="flex flex-col gap-4 mt-2">
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold">
          {translate("resources.tasks.name", { smart_count: 2 })}
        </h1>
        <TopToolbar>
          <CanAccess resource="tasks" action="create">
            <Button size="sm" onClick={() => setCreateOpen(true)}>
              <Plus className="size-4" />
              {translate("ra.action.create")}
            </Button>
          </CanAccess>
        </TopToolbar>
      </div>

      <Card>
        <CardContent className="pt-6">
          <TasksListContent />
        </CardContent>
      </Card>

      {/* No contact_id: the sheet then asks which contact -- or which project,
          for anyone who cannot see contacts. */}
      <TaskCreateSheet open={createOpen} onOpenChange={setCreateOpen} />
    </div>
  );
};

export default TaskList;
